import { useTranslation } from "react-i18next";
import { ExtraFarmBoostWrapper, LogoContainer, TextWrapper } from "./style";
import { ReactComponent as TradingIcon } from "../../assets/svg/bar-chart.svg";
import { TEXT_COLORS } from "../../constants/design/colors";
import { LINKS } from "../../constants/links";
import ExternalLinkText from "../ExternalLinkText";

export function ExtraFarmBoostDetails() {
  const { t } = useTranslation("app", {
    keyPrefix: "TradeForm.Common",
  });
  return (
    <ExtraFarmBoostWrapper>
      <LogoContainer>
        <TradingIcon />
      </LogoContainer>
      <TextWrapper>
        <span>
          {t("farm_boost_desc_1")}
          <span style={{ color: TEXT_COLORS.one }}>
            {t("farm_boost_desc_2")}
          </span>{" "}
          {t("farm_boost_desc_3")}
          <span style={{ color: TEXT_COLORS.one }}>
            {t("farm_boost_desc_4")}
          </span>
          {t("farm_boost_desc_5")}{" "}
          <ExternalLinkText
            href={LINKS.docs}
            target="_blank"
            rel="noreferrer"
            color={TEXT_COLORS.two}
            wrapperStyle={{
              fontSize: 12,
              display: "inline-block",
            }}
          >
            {t("learn_more")}
          </ExternalLinkText>
        </span>
      </TextWrapper>
    </ExtraFarmBoostWrapper>
  );
}
